import React, { useContext, useEffect, useState } from 'react';

import { noop } from 'lodash';
import { io } from 'socket.io-client';
import { useUserStore } from 'store/useUserStore';

export const SocketContext = React.createContext();

export const useSocketContext = () => useContext(SocketContext);

const SocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [currentSocketInstance, setCurrentSocketInstance] = useState(null);

  const loginStore = useUserStore();

  useEffect(() => {
    const socket = io(process.env.REACT_APP_SOCKET_URL);
    setCurrentSocketInstance(socket);

    socket.on('connect', () => {
      socket.emit('auth', { token: loginStore?.token?.accessToken });
    });

    socket.on('auth', (data) => {
      if (data?.message === 'OK') setIsConnected(true);
    });

    socket.on('disconnect', () => {
      setIsConnected(false);
    });

    return () => {
      return socket ? socket.disconnect() : noop;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginStore?.token?.accessToken]);

  return (
    <SocketContext.Provider value={{ socket: currentSocketInstance, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
